module.exports = __webpack_public_path__ + "img/ic_benifit_video.d7536ba3.png";